import { ErrorDisplay } from "@/components/ui/error-display";

interface MsalErrorStateProps {
  error: string | null;
  onRetry?: () => void;
  className?: string;
}

export function MsalErrorState({
  error,
  onRetry,
  className
}: MsalErrorStateProps) {
  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      // Default retry behavior - reload the page
      window.location.reload();
    }
  };

  return (
    <ErrorDisplay
      title="Authentication Error"
      message="Failed to initialize authentication system"
      error={error}
      onRetry={handleRetry}
      retryText="Retry"
      variant="destructive"
      fullPage
      className={className}
    />
  );
}
